import { Skeleton } from '@/components/ui/skeleton';

const LoadingState = () => {
  return (
    <div className='space-y-4 py-4'>
      <div className='flex items-center space-x-4'>
        <Skeleton className='h-4 w-[200px]' />
        <Skeleton className='h-4 w-[100px]' />
      </div>
      <Skeleton className='h-[300px] w-full' />
      <div className='flex items-center space-x-4'>
        <Skeleton className='h-4 w-[150px]' />
        <Skeleton className='h-4 w-[200px]' />
      </div>
    </div>
  );
};

export default LoadingState;
